import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { BehaviorSubject, catchError, map, Observable, tap, throwError } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TokenPermissionService {

  private api = environment.api_backend;

  private _token: BehaviorSubject<any> = new BehaviorSubject(false);
  get token$(): BehaviorSubject<any> { return this._token; }

  constructor(private _http: HttpClient) {}

  public generateToken(): Observable<any>
  {
    return this._http.get(this.api + '/mobile-utils/token-register').pipe(
      tap((result: any) => {
        if (result) {
          this._token.next(result);
          return result;
        } else {
          this._token.next({});
          return [];
        }
      }),
      map(res => {
        return res;
      }),
      catchError((err: HttpErrorResponse) => throwError(err))
    );
  }
}
